// extracted by mini-css-extract-plugin
export default {"content":"Detail_content__5nMG0"};